// extracted by mini-css-extract-plugin
export default {"form-control":"GoalInputs_form-control__RP2e8","invalid":"GoalInputs_invalid__y58MB","button":"GoalInputs_button__pxe0B"};